import '../styles/Quotes.css'
import { columnsProducts, columnsProductsAdmin, columnsProductsAdminGeneric } from '../Component/Hooks/ColumTables'
import Table from '../Component/Tabla/Tabla'
import { useContext, useEffect, useState } from 'react'
import LoginContext from '../Context/Logincontext';
import { urlApiServer } from '../Config/Config'
import EditProduct3D from '../Component/Hooks/EditProduct3D'
import EditProduct from '../Component/Hooks/EditProduct';

const Products = () => {
    const urlgetConfig = urlApiServer + "getConfig";
    const urlGetProduct = urlApiServer + "products";
    const [state, setState] = useState("0");
    const { infoUser } = useContext(LoginContext);
    const [powerEdit, setPowerEdit] = useState(true);
    const [productGetTable, setProductGetTable] = useState([]);
    const [id, setId] = useState();
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [oldConfig, setOldConfig] = useState("");
    const [logo, setLogo] = useState("");

    // Fetch config data
    useEffect(() => {
        const fetchConfig = async () => {
            const response = await fetch(urlgetConfig, {
                method: 'GET',
                headers: { "Content-Type": "application/json" }
            });
            const data = await response.json();
            setOldConfig(data);

            const companyConfig = data.find(obj => obj.empresa === infoUser.company);
            if (companyConfig) {
                setLogo(companyConfig.logo);
            }
        };

        fetchConfig();
    }, [infoUser.company]);

    // Fetch products data
    useEffect(() => {
        const fetchProducts = async () => {
            const response = await fetch(urlGetProduct, {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    "company": infoUser.company
                }
            });
            const data = await response.json();
            setProductGetTable(data.reverse());
        };

        fetchProducts();
    }, [state, infoUser.company]);

    const refreshData = () => setState(prev => prev === "0" ? "1" : "0");
    const toggleEdit = () => setPowerEdit(prev => !prev);

    const handleProductSelect = (id, product) => {
        setId(id);
        setSelectedProduct(product);
        toggleEdit(); // Esto activará el modo de edición
    };

    const handleUpdateProduct = async (updatedProduct) => {
        const urlEdit = urlApiServer + "editproduct";
        const response = await fetch(urlEdit, {
            method: 'PUT',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                empresa: infoUser.company,
                Id: updatedProduct.id,
                product: updatedProduct.producto,
                material: updatedProduct.material,
                long: updatedProduct.long,
                caliber: updatedProduct.caliber,
                price: updatedProduct.precioitem,
                iva: updatedProduct.iva,
                modeljson: null,
                Model: null,
                image: null,
                ancho: null,
                cantidad: 1,
                unit: updatedProduct.unit
            })
        });

        const dataResponse = await response.json();
        if (dataResponse.status === 560) {
            console.error('Error updating product');
        } else {
            refreshData();
            toggleEdit(); // Vuelve a la vista de tabla
        }
    };

    return (
        <>
            {!infoUser.login ? (
                window.location.href = './Iniciar_Sesión'
            ) : infoUser.role === 'SuperUsuario' ? (
                window.location.href = './Crear_Empresa'
            ) : powerEdit ? (
                <>
                    {infoUser.role === 'Administrador' ? (
                        <Table
                            columns={infoUser.companyType === "Generica" ? columnsProductsAdminGeneric : columnsProductsAdmin}
                            data={productGetTable}
                            edit={toggleEdit}
                            function={refreshData}
                            id={handleProductSelect}
                        />
                    ) : (
                        <Table
                            columns={columnsProducts}
                            data={productGetTable}
                            edit={toggleEdit}
                            function={refreshData}
                            id={handleProductSelect}
                        />
                    )}
                </>
            ) : infoUser.companyType === "Marmol" ? (
                <EditProduct3D
                    data={productGetTable}
                    edit={toggleEdit}
                    function={refreshData}
                    id={id}
                />
            ) : (
                <EditProduct
                    data={productGetTable}
                    product={selectedProduct}
                    onSave={handleUpdateProduct}
                    id={id}
                    onClose={() => setPowerEdit(true)} // Esto cerrará el modo edición
                />
            )}
        </>
    );
};

export default Products;